<template>
  <div>
    <div id="google-place-helper" ref="google-place-helper" v-show="false"></div>
    <v-combobox
      :label="label"
      v-model="model[modelKey]"
      :items="searchResults"
      :prepend-icon="prependIcon"
      item-text="title"
      item-value="place_id"
      hide-no-data
      hide-selected
      v-validate="'required'"
      :data-vv-name="modelKey"
      :data-vv-as="label"
      :error-messages="errors.collect(modelKey)"
      :required="required"
      :disabled="disabled"
      :loading="isLoading"
      :search-input.sync="search"
      :return-object="true"
      @input="getPlace"
      autocomplete="off"
    >
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title v-html="data.item.title"></v-list-item-title>
          <v-list-item-subtitle v-html="data.item.address"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-combobox>
  </div>
</template>

<script>
/* global google */
import Vue from 'vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import { googleApiKey } from '@/config';

export default {
  inject: ['$validator'],
  props: {
    model: {
      type: Object,
      required: true,
    },
    modelKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    prependIcon: {
      type: String,
    },
    types: {
      type: Array,
      default: () => ['geocode, establishment'],
    },
    country: {
      type: String,
    },
    autocompleteResponse: {
      type: Function,
      default: () => {},
    },
    required: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
    },
  },
  data() {
    return {
      google: null,
      autocompleteService: null,
      autocomplete: null,
      isLoading: false,
      search: null,
      searchResults: [],
    };
  },
  mounted() {
    GoogleMapsApiLoader({
      libraries: ['places'],
      apiKey: googleApiKey,
    }).then((google) => {
      this.google = google;
      this.autocompleteService = new google.maps.places.AutocompleteService();
    });
    if (this.model[this.modelKey]) {
      this.searchResults[0] = { title: this.model[this.modelKey] };
    }
  },
  methods: {
    async searchPlaces(value) {
      if (this.disabled) {
        return;
      }
      console.log(value, 'searchPlaces');
      if (!value || this.autocompleteService === null) {
        console.log('null');
        return;
      }
      const response = this.autocompleteService.getPlacePredictions({
        input: value,
        types: this.types,
        componentRestrictions: {
          country: this.country || [],
        },
      }, await this.displaySuggestions);
      console.log(response, 'response');
      return response;
    },
    async displaySuggestions(predictions, status) {
      if (status !== this.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = [];
        return;
      }
      this.searchResults = predictions.map((prediction) => ({
        title: prediction.structured_formatting.main_text || '',
        address: prediction.structured_formatting.secondary_text || '',
        place_id: prediction.place_id,
      }));
      return this.searchResults;
    },
    getPlace({ place_id }) {
      const placesService = new google.maps.places.PlacesService(this.$refs['google-place-helper']);
      const request = {
        placeId: place_id,
      };
      placesService.getDetails(request, (result, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.setPlace(result);
          return result;
        }
        return [];
      });
    },
    setPlace(place) {
      const address = {};
      address.name = place.name;
      address.place_id = place.place_id;
      address.phone = place.international_phone_number;
      address.website = place.website;
      address.latitude = place.geometry.location.lat();
      address.longitude = place.geometry.location.lng();
      if (place.address_components) {
        place.address_components.map((item) => {
          const addressType = item.types[0];
          address[addressType] = item.short_name;
          return item;
        });
      }
      this.autocompleteResponse(address);
      Vue.nextTick(() => {
        this.update(address.name);
      });
    },
    update(value) {
      this.$emit('autocomplete', value);
    },
  },
  watch: {
    search(val) {
      // Items have already been requested
      if (this.isLoading) { return; }

      this.isLoading = true;

      // Lazily load input items
      this.searchPlaces(val).then(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-text-field--autocomplete.error--text {
    .v-text-field__slot::before {
      border-color: #ff5252 !important;
    }
  }
</style>
